import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-pressed", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "au-lang",
    role: "group",
    "aria-label": _ctx.$t('nav.language')
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-translate" }, null, -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (code) => {
      return (_openBlock(), _createElementBlock("button", {
        key: code,
        type: "button",
        class: _normalizeClass({ 'is-active': code === _ctx.$i18n.locale }),
        "aria-pressed": code === _ctx.$i18n.locale,
        onClick: ($event: any) => (_ctx.change(code))
      }, _toDisplayString(code.toUpperCase()), 11, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}